module.exports = __webpack_public_path__ + "static/img/59.14e8afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/59.png
// module id = E5gz
// module chunks = 0